import { RokezzzLocalStorageService } from './rokezzz/local-storage/services/local-storage.service';

export const globals = {
    localStorageService: null as RokezzzLocalStorageService | null,
};
